import { render, staticRenderFns } from "./StudentExamResultFormModal.vue?vue&type=template&id=cfad11d0&scoped=true"
import script from "./StudentExamResultFormModal.vue?vue&type=script&lang=js"
export * from "./StudentExamResultFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfad11d0",
  null
  
)

export default component.exports